import React from "react";

import { ListGroup } from "react-bootstrap";

import "./restaurant.details.css";
import commonInformation from "./commonInformation";

class BranchList extends commonInformation {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                <ListGroup fill="true" style={{ padding: "10px" }}>
                    {this.props.branches.map((branch, i) => {
                        if (branch.deleted) {
                            return null;
                        }

                        return (
                            <div
                                key={branch._id}
                                style={{ padding: "10px" }}
                                onClick={() =>
                                    this.props.handleBranchEdit(branch, i)
                                }
                            >
                                {branch.name}
                            </div>
                        );
                    })}
                </ListGroup>
            </React.Fragment>
        );
    }
}

export default BranchList;
